"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upload = upload;

var _request = _interopRequireDefault(require("@/utils/request"));

/**
 * 详情
 * @param {int} id
 */
function upload(data) {
  return (0, _request.default)({
    url: '/upload',
    method: 'post',
    data: data
  });
}